import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AiSummaryBanner from '../IIMReview/components/AiSummaryBanner';
export default function IpaAssessmentBanner({ inspectionId, ipaScorecardEnabled = false, canOverrideAssessment = false }) {
    const [queryClient] = useState(() => new QueryClient());
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(AiSummaryBanner, { inspectionId: inspectionId, ipaScorecardEnabled: ipaScorecardEnabled, canOverride: canOverrideAssessment })));
}
